function pickVal(item, ...keys) {
  if (!item) return ''
  for (let i = 0; i < keys.length; i++) {
    const val = item[keys[i]]
    if (val !== undefined && val !== null && val !== '') return val
  }
  return ''
}

function isBound(item) {
  const val = pickVal(item, 'bound')
  return val === '1' || val === 1 || val === true
}

function joinUniqueLabel(...vals) {
  const seen = {}
  const parts = []
  vals.forEach((val) => {
    const text = String(val || '').trim()
    if (!text) return
    const key = text.toLowerCase()
    if (seen[key]) return
    seen[key] = true
    parts.push(text)
  })
  return parts.join('　')
}

/** 桩号数值按千位规则显示，如 8000 → K8+000 */
function formatStakeDisplay(value) {
  if (value === null || value === undefined || value === '') return ''
  const n = parseFloat(value)
  if (Number.isNaN(n) || n < 0) return ''
  const km = Math.floor(n / 1000)
  const meters = n - km * 1000
  const rounded = Math.round(meters * 1000) / 1000
  let meterStr
  if (Math.abs(rounded - Math.round(rounded)) < 1e-9) {
    meterStr = String(Math.round(rounded)).padStart(3, '0')
  } else {
    const fixed = rounded.toFixed(3).replace(/0+$/, '').replace(/\.$/, '')
    const parts = fixed.split('.')
    meterStr =
      parts[0].padStart(3, '0') + (parts[1] ? '.' + parts[1] : '')
  }
  return 'K' + km + '+' + meterStr
}

function buildFactoryLocationText(item) {
  const start = formatStakeDisplay(item.startStake)
  const end = formatStakeDisplay(item.endStake)
  let stakeText = ''
  if (start && end) stakeText = start + '~' + end
  else stakeText = start || end
  return [item.mark, item.lnglat, stakeText]
    .map((v) => String(v || '').trim())
    .filter(Boolean)
    .join('\n')
}

function mapFactoryBindOptions(list, type) {
  return (list || [])
    .map((item) => {
      if (type === 'labor') {
        return {
          value: pickVal(item, 'laborOrgUid', 'labororguid'),
          label: pickVal(item, 'laborOrgName', 'labororgname'),
          bound: item.bound
        }
      }
      if (type === 'car') {
        const name = pickVal(item, 'carName', 'carname')
        const code = pickVal(item, 'carCode', 'carcode')
        const model = pickVal(item, 'carModel', 'carmodel')
        return {
          value: pickVal(item, 'entryUid', 'entryuid'),
          label: joinUniqueLabel(code, name, model),
          bound: item.bound
        }
      }
      const name = pickVal(item, 'personName', 'personname')
      const phone = pickVal(item, 'personPhone', 'personphone')
      return {
        value: pickVal(item, 'entryUid', 'entryuid'),
        label: phone ? name + '　' + phone : name,
        bound: item.bound
      }
    })
    .filter((item) => item.value)
}

function normalizeBoundRow(item, type) {
  if (type === 'labor') {
    return {
      laborOrgUid: pickVal(item, 'laborOrgUid', 'labororguid'),
      laborOrgName: pickVal(item, 'laborOrgName', 'labororgname'),
      laborOrgCode: pickVal(item, 'laborOrgCode', 'labororgcode'),
      leaderName: pickVal(item, 'leaderName', 'leadername'),
      leaderPhone: pickVal(item, 'leaderPhone', 'leaderphone'),
      entryDate: pickVal(item, 'entryDate', 'entrydate'),
      noteInfo: pickVal(item, 'noteInfo', 'noteinfo') || '在场'
    }
  }
  if (type === 'car') {
    return {
      entryUid: pickVal(item, 'entryUid', 'entryuid'),
      carCode: pickVal(item, 'carCode', 'carcode'),
      carName: pickVal(item, 'carName', 'carname'),
      carModel: pickVal(item, 'carModel', 'carmodel'),
      carUsage: pickVal(item, 'carUsage', 'carusage'),
      entryDate: pickVal(item, 'entryDate', 'entrydate'),
      noteInfo: pickVal(item, 'noteInfo', 'noteinfo') || '在场',
      deviceCategory: pickVal(item, 'deviceCategory', 'devicecategory')
    }
  }
  return {
    entryUid: pickVal(item, 'entryUid', 'entryuid'),
    personName: pickVal(item, 'personName', 'personname'),
    jobTitle: pickVal(item, 'jobTitle', 'jobtitle'),
    personPhone: pickVal(item, 'personPhone', 'personphone'),
    entryDate: pickVal(item, 'entryDate', 'entrydate'),
    noteInfo: pickVal(item, 'noteInfo', 'noteinfo') || '在场'
  }
}

async function loadFactoryBindForm(commit, dispatch, factoryUid, type) {
  const fun =
    type === 'car'
      ? 'getFactoryCars'
      : type === 'labor'
      ? 'getFactoryLabors'
      : 'getFactoryAdmins'
  const list = await dispatch(fun, factoryUid)
  const options = mapFactoryBindOptions(list, type)
  commit(
    'baseSet',
    { module: 'organization', key: 'factoryBindOptions', value: options },
    { root: true }
  )
  const boundKeys = options.filter((item) => isBound(item)).map((item) => item.value)
  return {
    uid: factoryUid,
    boundKeys: boundKeys,
    originalBoundKeys: boundKeys.slice()
  }
}

function saveFactoryBind(dispatch, data, type) {
  const uid = data && (data.uid || data.factoryUid)
  const current = ((data && data.boundKeys) || []).filter(Boolean)
  const original = ((data && data.originalBoundKeys) || []).filter(Boolean)
  const unbindKeys = original.filter((id) => current.indexOf(id) === -1)
  if (type === 'labor') {
    return dispatch('bindFactoryLabors', {
      uid: uid,
      bindLaborOrgUids: current,
      unbindLaborOrgUids: unbindKeys
    })
  }
  const payload = {
    uid: uid,
    bindEntryUids: current,
    unbindEntryUids: unbindKeys
  }
  return dispatch(type === 'car' ? 'bindFactoryCars' : 'bindFactoryAdmins', payload)
}

async function loadFactoryBoundList(commit, dispatch, factoryUid, type) {
  const fun =
    type === 'car'
      ? 'getFactoryCars'
      : type === 'labor'
      ? 'getFactoryLabors'
      : 'getFactoryAdmins'
  const key =
    type === 'car'
      ? 'factoryCarList'
      : type === 'labor'
      ? 'factoryLaborList'
      : 'factoryAdminList'
  const list = await dispatch(fun, factoryUid)
  const bound = (list || [])
    .filter((item) => isBound(item))
    .map((item) => normalizeBoundRow(item, type))
  commit(
    'baseSet',
    { module: 'organization', key: key, value: bound },
    { root: true }
  )
  return bound
}

export default {
  namespaced: true,
  state: {
    organRelations: [], // 缓存当前选择机构的组织机构关系
    orgFactory: [], // 缓存机构下场站工区信息
    factoryBindOptions: [],
    factoryAdminList: [],
    factoryCarList: [],
    factoryLaborList: []
  },
  actions: {
    // 添加组织关系
    async addOrganRelations({ dispatch }, data) {
      let payload = data
      if (Array.isArray(data) && data.length && Array.isArray(data[0].startUid)) {
        payload = data.flatMap((item) =>
          (item.startUid || []).map((uid) => ({ ...item, startUid: uid }))
        )
      } else if (!Array.isArray(data) && data && Array.isArray(data.startUid)) {
        payload = data.startUid.map((uid) => ({ ...data, startUid: uid }))
      }
      if (Array.isArray(payload)) {
        payload = payload.filter((item) => item && item.startUid)
      }
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/org/level',
          data: payload,
          msg: '添加组织关系成功'
        },
        { root: true }
      )
      return res
    },
    // 删除组织关系
    async deleteOrganRelations({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/organize/org/level',
          data: { uid: uid },
          msg: '删除组织关系成功'
        },
        { root: true }
      )
      return res
    },
    // 获取组织关系列表
    async getOrganRelationsList(
      { rootState, rootGetters, commit, dispatch },
      uid
    ) {
      var orgUid = uid ? uid : rootState.activeNav
      if (!orgUid) {
        commit(
          'baseSet',
          { module: 'organization', key: 'organRelations', value: [] },
          { root: true }
        )
        return
      }
      const res = await dispatch(
        'baseRequest',
        { method: 'GET', url: '/organize/org/level', data: { orgUid: orgUid } },
        { root: true }
      )
      if (res.data) {
        const organRelations = res.data.filter((item) => {
          return item.professionalType !== '直属标段'
        })
        organRelations.forEach((item) => {
          item.disabledButtons = []
          if (rootGetters['user/orgName'] !== '甘肃大鹏鸟科技有限公司') {
            if (item.relationType === '上级组织') {
              item.disabledButtons = [0]
            }
          }
        })
        commit(
          'baseSet',
          { module: 'organization', key: 'organRelations', value: organRelations },
          { root: true }
        )
      }
    },
    // 添加机构下职能部门
    async addOrgDepartment({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/person/template/department',
          data: data,
          msg: '添加职能部门成功'
        },
        { root: true }
      )
      return res
    },
    // 删除机构下职能部门
    async deleteOrgDepartment({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/person/template/department',
          data: { uid: uid },
          msg: '删除职能部门成功'
        },
        { root: true }
      )
      return res
    },
    async syncOrgDepartment({ rootState, dispatch }, mode) {
      const projectUid = rootState.user.orgValue
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url:
            '/person/template/department/sync?projectUid=' +
            encodeURIComponent(projectUid || '') +
            '&mode=' +
            encodeURIComponent(mode || 'fill'),
          data: {},
          msg: true
        },
        { root: true }
      )
      return res
    },
    // 获取机构下职能部门
    async getOrgDepartment({ rootState, dispatch }, uid) {
      var projectUid = uid ? uid : rootState.user.orgValue
      await dispatch(
        'orgFieldsRequest',
        {
          key: 'department',
          label: 'name',
          value: 'uid',
          childrenKey: 'list',
          url: '/person/template/department',
          data: { projectUid: projectUid }
        },
        { root: true }
      )
    },
    // 编辑科室部门
    async editOrgDepartment({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/person/template/department',
          data: data,
          msg: '编辑职能部门成功'
        },
        { root: true }
      )
      return res
    },
    // 添加机构下场站工区
    async addOrgFactory({ dispatch }, data) {
      const payload = Object.assign({}, data || {})
      const adminPersonUid = payload.adminPersonUid
      delete payload.admin
      delete payload.adminPersonUid
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/template/orgfactory',
          data: payload,
          msg: '添加场站工区成功'
        },
        { root: true }
      )
      if (res && res.code === 200 && adminPersonUid && res.data) {
        const factoryUid =
          typeof res.data === 'string'
            ? res.data
            : res.data.uid || res.data.factoryUid
        if (factoryUid) {
          await dispatch('bindFactoryAdmins', {
            uid: factoryUid,
            bindEntryUids: [],
            bindPersonUids: [adminPersonUid],
            unbindEntryUids: [],
            silent: true
          })
        }
      }
      return res
    },
    // 删除机构下场站工区
    async deleteOrgFactory({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/organize/template/orgfactory',
          data: { uid: uid },
          msg: '删除场站工区成功'
        },
        { root: true }
      )
      return res
    },
    // 获取机构下场站工区
    async getOrgFactory({ rootState, commit, dispatch }, uid) {
      var orgUid = uid ? uid : rootState.user.orgValue
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/template/orgfactory',
          data: { orgUid: orgUid }
        },
        { root: true }
      )
      var orgFactory = res.data ? res.data : []
      orgFactory.forEach((item) => {
        item.value = item.uid
        item.label =
          item.name + '\xa0\xa0' + item.adminName + '\xa0\xa0' + item.adminPhone
        item.admin = {
          value: '',
          label: item.adminName,
          phoneNumber: item.adminPhone
        }
        item.adminPersonUid = ''
        const adminCount = item.adminCount != null ? item.adminCount : 0
        const carCount = item.carCount != null ? item.carCount : 0
        const laborCount = item.laborCount != null ? item.laborCount : 0
        item.adminCountText = adminCount + '个管理人员'
        item.carCountText = carCount + '台机械设备'
        item.laborCountText = laborCount + '家劳务公司'
        item.locationText = buildFactoryLocationText(item)
      })
      commit(
        'baseSet',
        { module: 'organization', key: 'orgFactory', value: orgFactory },
        { root: true }
      )
    },
    // 编辑场站工区
    async editOrgFactory({ dispatch }, data) {
      const payload = Object.assign({}, data || {})
      const adminPersonUid = payload.adminPersonUid
      const factoryUid = payload.uid
      delete payload.admin
      delete payload.adminPersonUid
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/template/orgfactory',
          data: payload,
          msg: '编辑场站工区成功'
        },
        { root: true }
      )
      if (res && res.code === 200 && adminPersonUid && factoryUid) {
        await dispatch('bindFactoryAdmins', {
          uid: factoryUid,
          bindEntryUids: [],
          bindPersonUids: [adminPersonUid],
          unbindEntryUids: [],
          silent: true
        })
      }
      return res
    },
    async getFactoryAdmins({ dispatch }, factoryUid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/template/orgfactory/admins',
          data: { factoryUid: factoryUid }
        },
        { root: true }
      )
      return res && res.data ? res.data : []
    },
    async bindFactoryAdmins({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/template/orgfactory/bindadmins',
          data: data,
          msg: data && data.silent ? false : true
        },
        { root: true }
      )
      return res
    },
    async getFactoryCars({ dispatch }, factoryUid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/template/orgfactory/cars',
          data: { factoryUid: factoryUid }
        },
        { root: true }
      )
      return res && res.data ? res.data : []
    },
    async bindFactoryCars({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/template/orgfactory/bindcars',
          data: data,
          msg: true
        },
        { root: true }
      )
      return res
    },
    async getFactoryLabors({ dispatch }, factoryUid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/template/orgfactory/labors',
          data: { factoryUid: factoryUid }
        },
        { root: true }
      )
      return res && res.data ? res.data : []
    },
    async bindFactoryLabors({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/template/orgfactory/bindlabors',
          data: data,
          msg: true
        },
        { root: true }
      )
      return res
    },
    async getFactoryAdminBindForm({ commit, dispatch }, factoryUid) {
      return loadFactoryBindForm(commit, dispatch, factoryUid, 'admin')
    },
    async getFactoryCarBindForm({ commit, dispatch }, factoryUid) {
      return loadFactoryBindForm(commit, dispatch, factoryUid, 'car')
    },
    async getFactoryLaborBindForm({ commit, dispatch }, factoryUid) {
      return loadFactoryBindForm(commit, dispatch, factoryUid, 'labor')
    },
    async saveFactoryAdminBind({ dispatch }, data) {
      const res = await saveFactoryBind(dispatch, data, 'admin')
      if (res && res.code === 200) await dispatch('getOrgFactory')
      return res
    },
    async saveFactoryCarBind({ dispatch }, data) {
      const res = await saveFactoryBind(dispatch, data, 'car')
      if (res && res.code === 200) await dispatch('getOrgFactory')
      return res
    },
    async saveFactoryLaborBind({ dispatch }, data) {
      const res = await saveFactoryBind(dispatch, data, 'labor')
      if (res && res.code === 200) await dispatch('getOrgFactory')
      return res
    },
    async getFactoryAdminList({ commit, dispatch }, factoryUid) {
      return loadFactoryBoundList(commit, dispatch, factoryUid, 'admin')
    },
    async getFactoryCarList({ commit, dispatch }, factoryUid) {
      return loadFactoryBoundList(commit, dispatch, factoryUid, 'car')
    },
    async getFactoryLaborList({ commit, dispatch }, factoryUid) {
      return loadFactoryBoundList(commit, dispatch, factoryUid, 'labor')
    }
  }
}
